<template>
  <div class="menuStyle">
    <el-menu
      class="el-menu-vertical-demo"
      :collapse="isCollapse"
      text-color="#09152D"
      background-color="#F6F7FB"
      :unique-opened="false"
      :default-openeds="defaultOpeneds"
      router
      :default-active="$route.path"
      @open="handleMenuOpen"
      @close="handleMenuClose"
      popper-class="nav-side-pop"
    >
      <template v-for="(item, index) in menus">
        <el-submenu
          :index="index.toString()"
          v-if="item.children && item.children.length > 0"
        >
          <template slot="title">
            <img
              :src="
                getImageUrl(item.icon ? item.icon : '')
              "
              alt
              style="margin-right: 11px; width: 16px"
            />
            <span>{{ item.title }}</span>
          </template>

          <el-menu-item
            :index="innerItem.path"
            v-for="(innerItem, innerIndex) in item.children"
            :key="innerIndex"
            >{{ innerItem.title }}</el-menu-item
          >
        </el-submenu>
        <el-menu-item
          v-else
          :index="item.path"
        >
          <img
            :src="
              getImageUrl(item.icon ? item.icon : '')
            "
            alt
            style="margin-right: 11px; width: 16px"
          />
          <template slot="title">
            <!-- <a
              class="link"
              :href="item.path"
              target="_blank"
              v-if="item.target && item.target == '_blank'"
              style="color: #09152d;"
              >{{ item.title }}</a
            >
            <span v-else>{{ item.title }}</span> -->
            <span>{{ item.title }}</span>
          </template>
        </el-menu-item>
      </template>
    </el-menu>
    <div
      @click="isCollapse = !isCollapse"
      class="collapse"
      :style="{ 'padding-left': isCollapse ? '20px' : '34px' }"
    >
      <img
        :src="getImageUrl(isCollapse ? 'collapse_open' : 'collapse_close')"
        alt
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import "element-ui/lib/theme-chalk/index.css";

export default {
  data() {
    return {
      isCollapse: false,
      defaultOpeneds: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    };
  },
  computed: {
    ...mapState(["menus"]),
  },
  mounted() {},
  methods: {
    getImageUrl(name) {
      return `/images/navside/${name}.png`;
    },
    handleMenuOpen(activeIndex) {
      !this.defaultOpeneds.includes(activeIndex) &&
        this.defaultOpeneds.push(activeIndex);
    },
    handleMenuClose(activeIndex) {
      const index = this.defaultOpeneds.findIndex((m) => m === activeIndex);
      index >= 0 && this.defaultOpeneds.splice(index, 1);
    },
  },
};
</script>

<style lang="stylus" scoped>
.menuStyle
  box-sizing border-box
  position relative
  height 100%;

  >>>.el-menu-vertical-demo
    border none
    // background #33475d
    border 0
    padding 6px 0 14px
    color #999999
    box-shadow: 0px -1px 0px rgba(0, 21, 41, 0.08);
    height calc(100% - 46px)
    overflow-y: auto;
    .el-submenu
      .el-menu
        .el-menu-item
          padding-left 62px !important
          margin-top 0px
      .el-icon-arrow-down
        color rgba(0,0,0,.25)
    .el-submenu__title
      margin-top 0px
      padding-left 34px !important
      padding-right 20px !important
      height 40px
      line-height 40px
      color #09152D !important
      cursor pointer
      font-size 14px
      font-weight lighter
      &:hover
        background #DDEAFF !important
    .el-menu-item, .el-submenu__title
      height 40px
      line-height 40px
      margin-top 8px
      margin-bottom 8px
      padding-left 34px !important
      font-weight lighter
      color #09152D !important
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      box-sizing border-box
      &:hover
        background #DDEAFF !important
        color #0B51C1
      &.is-active
        background #DDEAFF !important
        color #0B51C1 !important
        position relative
        &:before {
          content: "";
          display inline-block
          width: 6px;
          height: 40px;
          background: #0b51c1;
          border-radius: 0px 100px 100px 0px;
          position absolute
          left 0
          top 0
          bottom 0
        }
  >>>.el-menu-vertical-demo:not(.el-menu--collapse)
    width 256px
    min-height 400px
  >>>.el-menu--collapse {
    .el-submenu__title {
      padding-left 20px !important
    }
  }
  .collapse
    width 30px
    height 46px
    font-size 30px
    cursor pointer
    padding-left 34px
    img
      width: 16px
</style>
